var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-view" }, [
    _c(
      "div",
      { staticClass: "main-content" },
      [
        _c("search-bar", {
          ref: "searchBar",
          attrs: {
            "type-list": _vm.typeList,
            "show-refresh": false,
            "show-input-val": false,
            "ocr-tab": _vm.OCR_TAB_IDENTIFY.code,
            source: _vm.source
          },
          on: { change: _vm.searchChange }
        }),
        _c(
          "div",
          {
            staticStyle: {
              height: "100%",
              "justify-content": "space-between",
              display: "flex",
              border: "1px solid #BDC3C7"
            },
            on: { click: _vm.triggerUpload }
          },
          [
            _c(
              "div",
              {
                staticClass: "drop-uploader-icon",
                staticStyle: { width: "100%", "text-align": "center" }
              },
              [
                _vm._m(0),
                _c("div", [
                  _c(
                    "p",
                    { staticStyle: { "font-size": "20px", color: "#2d2f33" } },
                    [
                      _vm._v(" " + _vm._s(_vm.$t("CargoMsg.Cargo_Will")) + " "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "20px",
                            "font-weight": "bold"
                          }
                        },
                        [_vm._v(_vm._s(_vm.fileTypeText))]
                      ),
                      _vm._v(" " + _vm._s(_vm.$t("CargoMsg.Cargo_DFI")) + " "),
                      _c(
                        "span",
                        { staticStyle: { "font-size": "20px", color: "blue" } },
                        [_vm._v(_vm._s(_vm.$t("Message.ClickUpload")))]
                      )
                    ]
                  ),
                  _c(
                    "p",
                    { staticStyle: { "font-size": "14px", color: "#2d2f33" } },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.SupportUploadFormat")) +
                          "pdf/xls/xlsx/doc/docx/jpg/gif/png"
                      )
                    ]
                  )
                ])
              ]
            ),
            _c(
              "div",
              { staticClass: "watermark" },
              _vm._l(_vm.watermarkTexts, function(item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "watermark-text" },
                  [_vm._v(_vm._s(item))]
                )
              }),
              0
            )
          ]
        ),
        _c("drop-uploader", {
          ref: "dropUploader",
          attrs: {
            action: _vm.URL.AIdiscern.importAndAnalyseFile,
            "upload-params": {
              source: _vm.source,
              iChannel: String(_vm.iChannel),
              jobUuid: _vm.jobUuid,
              docUuid: _vm.docUuid,
              pageSource: "ocr",
              officeId: _vm.$store.getters.currentOfficeId
            },
            accept: [
              "pdf",
              "xls",
              "xlsx",
              "doc",
              "docx",
              "jpg",
              "gif",
              "png",
              "msword",
              "ms-excel",
              "jpeg"
            ],
            "bs-open": _vm.bsOpen,
            "open-drag": _vm.openDrag && _vm.bsOpen,
            "channel-open": _vm.channelOpen,
            "bs-remaining-amount-enough": _vm.bsRemainingAmountEnough,
            "file-format": _vm.fileFormat
          },
          on: { "upload-end": _vm.uploadEnd }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("i", { staticClass: "el-icon-upload" })])
  }
]
render._withStripped = true

export { render, staticRenderFns }